import { createRouter, createWebHistory } from 'vue-router';
import { usePuzzleStore } from '@/stores/puzzleStore';
import ChessBoard from '@/components/ChessBoard.vue';
import Search from '@/components/SearchView.vue';
import Analysis from '@/components/AnalysisView.vue';
import BlunderBoard from '@/components/BlunderBoard.vue';

const routes = [
  { 
    path: '/',
    component: Search,
    name: 'search' 
  },
  { 
    path: '/puzzles', 
    component: ChessBoard, 
    name: 'chessboard',
    beforeEnter: (to, from, next) => {
      const store = usePuzzleStore();
      if (store.puzzles.length === 0) {
        next({ name: 'search' });
      } else {
        next();
      }
    },
   },
  { 
    path: '/analysis', 
    component: Analysis, 
    name: 'analysis',
    beforeEnter: (to, from, next) => {
      const store = usePuzzleStore();
      if (store.puzzles.length === 0) {
        next({ name: 'search' });
      } else {
        next();
      }
    },
   },
  { 
    path: '/blunders',
    component: BlunderBoard,
    name: 'blunders',
    beforeEnter: (to, from, next) => {
      const store = usePuzzleStore();
      if (store.puzzles.length === 0) {
        next({ name: 'search' });
      } else {
        next();
      }
    },
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;